import React, { useCallback, useRef } from 'react'

import { ViewportList, ViewportListRef } from 'react-viewport-list'
import {
  activateNext,
  activatePrevious,
} from '../../../../../firebase/hooks/useTray'
import { type TrayCard as TrayCardType } from '../../../../../firebase/model/tray-cards/cards-model'
import { TrayCard } from '../../../../../Webinar/components/Tray/TrayCard'

import {
  useFilteredTrayCards,
  useAutoScrollToActive,
  useClickerKeys,
} from './focusTrayUtils'

import './FocusTray.scss'

interface FocusTrayProps {
  filter: TrayCardType['type'][]
}

const FocusTray = ({ filter }: FocusTrayProps) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const cardListRef = useRef<ViewportListRef>(null)
  const filteredCards = useFilteredTrayCards(filter)

  useAutoScrollToActive(cardListRef, filteredCards)

  const previousCard = useCallback(() => {
    activatePrevious(filter)
  }, [filter])

  const nextCard = useCallback(() => {
    activateNext(filter)
  }, [filter])

  useClickerKeys(previousCard, nextCard, filter.includes('image') ? 1 : 0)

  return (
    <div className="focus-tray">
      <div className="focus-tray-list" ref={ref} style={{}}>
        <ViewportList
          ref={cardListRef}
          viewportRef={ref}
          items={filteredCards}
          axis="y"
          overscan={100}
          scrollThreshold={1}
          withCache
          initialDelay={500}
        >
          {([_, cardId]) =>
            cardId.startsWith('filler') ? (
              <div key={cardId} className="focus-tray-list-filler" />
            ) : (
              <TrayCard key={cardId} id={cardId} />
            )
          }
        </ViewportList>
      </div>
    </div>
  )
}

export { FocusTray }
